// extracted by mini-css-extract-plugin
export default {"cardBody":"style_cardBody__UJXJg","v2":"style_v2__h0WQz","hoveredCardBody":"style_hoveredCardBody__Xeiic","cardBodyNotClickable":"style_cardBodyNotClickable__nSKRX"};